import { Box, Typography } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { OreveButton } from "components/button/OreveButton.tsx";
import DeleteIcon from '@mui/icons-material/Delete';
import CreditCard from "assets/svg/credit-card.svg"
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CardNumberInput } from "layouts/payment/utils"
import { UseAllPaymentContext } from 'layouts/payment/payment-context.tsx'
import { MainPageContentContainer } from "components/MainPageContentContainer.tsx";

const NoPaymentSpecified = () => {
    return (
        <MainPageContentContainer
            sx={{
                width: '100%',
                height: "100%",
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: "secondary.main"
            }}
        >
            <CreditCardIcon />
            <Typography variant="body">Aucun mode de paiement spécifique de renseigné.</Typography>
        </MainPageContentContainer>

    );
};
const DisplayPaymentCard = () => {
    const { payments, removePayment } = UseAllPaymentContext();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: "secondary.main",
                width: '100%',
                height: payments?.length && payments.length > 3 ? 'calc(100vh - (80px + 50px + 60px + 5rem))' : 'auto',
                overflowY: 'auto',
            }}
        >
            {payments &&
                payments.map((payment, index) => {
                    const paymentType = payment.type === 'CREDIT_CARD' ? "Carte bancaire" : "Prélèvement automatique"
                    return (
                        <MainPageContentContainer
                            key={index}
                            sx={{
                                width: '100%',
                                mb: '1rem',
                            }}
                        >
                            {payment.type === 'CREDIT_CARD' ?
                                <>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        mb: '1.5rem'
                                    }}>
                                        <Typography variant="titleLarge">
                                            {paymentType}
                                        </Typography>
                                        <OreveButton
                                            value='Supprimer'
                                            variant={'text'}
                                            icon={DeleteIcon}
                                            onClick={() => {
                                                removePayment(index)
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '1rem'
                                    }}>
                                        <img src={CreditCard} alt={"credit card"} />
                                        <Box>
                                            <Typography variant="title" color="textPrimary">
                                                Numéro de carte : {"cardNumber" in payment.payment_data ? payment.payment_data.cardNumber : null}
                                            </Typography>
                                            <Typography variant="bodyLarge" color="textSecondary">
                                                Titulaire : {payment.name}
                                            </Typography>
                                            <Typography variant="bodyLarge" color="textSecondary">
                                                Date d’expiration : {"expirationDate" in payment.payment_data ? payment.payment_data.expirationDate : null}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </>
                                :
                                <>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}>
                                        <Typography variant="titleLarge">
                                            {paymentType}
                                        </Typography>
                                        <OreveButton
                                            value='Télécharger le mandat SEPA'
                                            variant={'text'}
                                            icon={FileDownloadIcon}
                                        />
                                        <OreveButton
                                            value='Supprimer'
                                            variant={'text'}
                                            icon={DeleteIcon}
                                            onClick={() => { removePayment(index) }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography sx={{ mt: "16px", mb: "16px" }} variant="bodyLarge" color="textSecondary">
                                            Titulaire : {payment.name}
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
                                            <Typography variant="title" color="textPrimary">
                                                IBAN
                                            </Typography>
                                            <CardNumberInput cardNumber={"IBAN" in payment.payment_data ? payment.payment_data.IBAN : ''} />
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '24px' }}>
                                            <Typography variant="title" color="textPrimary">
                                                BIC
                                            </Typography>
                                            <CardNumberInput cardNumber={"BIC" in payment.payment_data ? payment.payment_data.BIC : ''} />
                                        </Box>
                                    </Box>
                                </>
                            }
                        </MainPageContentContainer>);
                })}
        </Box>
    )
}

export const ContainerDisplayPayment = () => {
    const { payments } = UseAllPaymentContext();

    return (
        <>
            {payments === null || payments.length === 0 ? (
                <NoPaymentSpecified />
            ) : (
                <DisplayPaymentCard />
            )}
        </>
    );
};